import { render, staticRenderFns } from "./Form2_Persona2.vue?vue&type=template&id=a65178e0&"
import script from "./Form2_Persona2.vue?vue&type=script&lang=js&"
export * from "./Form2_Persona2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65178e0')) {
      api.createRecord('a65178e0', component.options)
    } else {
      api.reload('a65178e0', component.options)
    }
    module.hot.accept("./Form2_Persona2.vue?vue&type=template&id=a65178e0&", function () {
      api.rerender('a65178e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/PRESTAMA/Form2_Persona2.vue"
export default component.exports